import { __extends } from "tslib";
import { ShaderCodeNode } from './shaderCodeNode';
/** @hidden */
var ShaderCodeTestNode = /** @class */ (function (_super) {
    __extends(ShaderCodeTestNode, _super);
    function ShaderCodeTestNode() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ShaderCodeTestNode.prototype.isValid = function (preprocessors) {
        return this.testExpression.isTrue(preprocessors);
    };
    return ShaderCodeTestNode;
}(ShaderCodeNode));
export { ShaderCodeTestNode };
//# sourceMappingURL=shaderCodeTestNode.js.map